/**
 * Navigation back to Hi5 Crew.
 *
 * The Crew app's WebView API is unknown at this point, so this uses only standard browser
 * behavior: a return URL handed over at launch (accepted only for allow-listed origins,
 * VITE_CREW_RETURN_ORIGINS), otherwise history back / window close. Wire a native bridge in
 * here once the Crew WebView contract is known.
 */
const RETURN_KEY = 'chromarble.crewReturnUrl';

function allowedOrigins(): string[] {
  return String(import.meta.env.VITE_CREW_RETURN_ORIGINS ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function rememberReturnUrl(candidate: string | null): void {
  if (!candidate) return;
  try {
    const url = new URL(candidate);
    if (allowedOrigins().includes(url.origin)) sessionStorage.setItem(RETURN_KEY, url.toString());
  } catch {
    /* ignore invalid */
  }
}

export function hasCrewReturn(): boolean {
  try {
    return Boolean(sessionStorage.getItem(RETURN_KEY));
  } catch {
    return false;
  }
}

export function returnToCrew(): void {
  let target: string | null = null;
  try {
    target = sessionStorage.getItem(RETURN_KEY);
  } catch {
    /* storage blocked */
  }
  if (target) {
    window.location.href = target;
    return;
  }
  if (window.history.length > 1) {
    window.history.back();
    return;
  }
  window.close();
}
